module.exports = __webpack_public_path__ + "img/96a4d42.jpg";